import { Variation } from '@/@core/services/app.service'
import { TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Stack,
  Typography,
  Box,
  Chip,
  IconButton,
  Badge,
  Slide
} from '@mui/material'

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import { styled } from '@mui/material/styles'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import { ExternalLinks } from '@/@core/services/api'
import { Circle, CircleHalfFull, MenuDown } from 'mdi-material-ui'
import {
  addCommas,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  unique
} from '@/@core/utils/utils'
import { useRouter } from 'next/router'
import { Rating } from '@mui/material'

interface Props {
  setCurrent: any
  setOpen: any
  setHistoryOpen: any
  setCommentsOpen: any
  setTranscript_list: any
  handleMenuClick: any
  getColumnSearchProps: any
  setFilterGeneOpen: any
  setMenuType: any
  setFilterGeneData: any
  getFilterGene: any
  setIndexOpen: any
  setGeneIndexOpen: any
  setGeneOpen: any
  setAcmgOpen: any
  setOMIMOpen: any
  setIgvOpen: any
  setIgvLocus: any
  setCnvScipOpen: any
  setCnvAllOpen: any
  VariationGeneRef: any
  analysisInfo: any
  query: any
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    maxHeight: 400,
    overflow: 'auto'
  }
})
const chromosome = [
  {
    text: 'chr1',
    value: '1'
  },
  {
    text: 'chr2',
    value: '2'
  },
  {
    text: 'chr3',
    value: '3'
  },
  {
    text: 'chr4',
    value: '4'
  },
  {
    text: 'chr5',
    value: '5'
  },
  {
    text: 'chr6',
    value: '6'
  },
  {
    text: 'chr7',
    value: '7'
  },
  {
    text: 'chr8',
    value: '8'
  },
  {
    text: 'chr9',
    value: '9'
  },
  {
    text: 'chr10',
    value: '10'
  },
  {
    text: 'chr11',
    value: '11'
  },
  {
    text: 'chr12',
    value: '12'
  },
  {
    text: 'chr13',
    value: '13'
  },
  {
    text: 'chr14',
    value: '14'
  },
  {
    text: 'chr15',
    value: '15'
  },
  {
    text: 'chr16',
    value: '16'
  },
  {
    text: 'chr17',
    value: '17'
  },
  {
    text: 'chr18',
    value: '18'
  },
  {
    text: 'chr19',
    value: '19'
  },
  {
    text: 'chr20',
    value: '20'
  },
  {
    text: 'chr21',
    value: '21'
  },
  {
    text: 'chr22',
    value: '22'
  },
  {
    text: 'chrX',
    value: 'X'
  },
  {
    text: 'chrY',
    value: 'Y'
  },
  {
    text: 'chrMT',
    value: 'MT'
  }
]

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

export const judgeType = (str: string, arr: any[]) => {
  if (str.includes('child') && !str.includes('//')) {
    return 'C'
  } else if (str.includes('child') && str.includes('//')) {
    return `C${str.split('//')[1]}`
  } else if (str.includes('mother')) {
    return 'M'
  } else if (str.includes('father')) {
    return 'F'
  } else {
    return 'O'
  }
}

const columns2Thalassemia = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const router = useRouter()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

  const column: TableColumnsType<Variation> = React.useMemo(() => {
    return [
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('type')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'type',
        key: 'type',
        align: 'center',
        width: 100,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              {row.variant.ref ? (
                <TypographyA>SNV/INDEL</TypographyA>
              ) : (
                <TypographyA>SV</TypographyA>
              )}
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Chrom')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'chrom',
        key: 'chrom',
        align: 'center',
        width: 180,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              {row.variant.ref ? (
                <React.Fragment>
                  <TypographyA>{`${row.variant.chrom}:${row.variant.pos}`}</TypographyA>

                  <TypographyA>{`${row.variant.ref}-${row.variant.alt}`}</TypographyA>

                  <TypographyA>{`${row.dbSNP_IDs}`}</TypographyA>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <TypographyA>{`${row.variant.chrom}`}</TypographyA>

                  <TypographyA>{`${row.variant.start}-${row.variant.end}`}</TypographyA>

                  <TypographyA>{`${row.variant.type}`}</TypographyA>
                </React.Fragment>
              )}
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('hb name')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'hb_name',
        key: 'hb_name',
        align: 'center',
        width: 180,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <Tooltip title={row.hb_name}>
                <TypographyA
                  sx={{
                    maxWidth: 180,
                    lineHeight: '24px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.hb_name}`}
                </TypographyA>
              </Tooltip>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('hgvs name')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'hgvs_name',
        key: 'hgvs_name',
        align: 'center',
        width: 180,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <Tooltip title={row.hgvs_name}>
                <TypographyA
                  sx={{
                    maxWidth: 180,
                    lineHeight: '24px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.hgvs_name}`}
                </TypographyA>
              </Tooltip>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('syll name')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'syll_name',
        key: 'syll_name',
        align: 'center',
        width: 180,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <Tooltip title={row.syll_name}>
                <TypographyA
                  sx={{
                    maxWidth: 180,
                    lineHeight: '24px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.syll_name}`}
                </TypographyA>
              </Tooltip>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'column'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('mutation location')}
              </span>
            </Stack>

            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('type of thal')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'type_of_thal',
        key: 'type_of_thal',
        align: 'center',
        width: 250,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>{`${row.mutation_location}`}</TypographyA>

              <TypographyA>{`${row.type_of_thal}`}</TypographyA>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'column'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('dna proof')}
              </span>
            </Stack>

            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('protein proof')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'dna_proof',
        key: 'dna_proof',
        align: 'center',
        width: 150,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>{`${row.dna_proof}`}</TypographyA>

              <TypographyA>{`${row.protein_proof}`}</TypographyA>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('dna description')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'dna_description',
        key: 'dna_description',
        align: 'center',
        width: 180,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={400}
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <Tooltip title={row.dna_description}>
                <TypographyA
                  sx={{
                    maxWidth: 250,
                    lineHeight: '24px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >{`${row.dna_description}`}</TypographyA>
              </Tooltip>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'column'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('occurrence comment')}
              </span>
            </Stack>

            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('general comments')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'occurrence_comment',
        key: 'occurrence_comment',
        align: 'center',
        width: 180,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <Tooltip title={row.occurrence_comment}>
                <TypographyA
                  sx={{
                    maxWidth: 250,
                    lineHeight: '24px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >{`${row.occurrence_comment}`}</TypographyA>
              </Tooltip>

              <TypographyA>{`${row.general_comments}`}</TypographyA>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('PubMed ID')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'hgvs_name',
        key: 'hgvs_name',
        align: 'center',
        width: 180,
        ellipsis: true,
        sorter: false,
        render: (value, row: any) => {
          const PubMed_ID =
            row.PubMed_ID && row.PubMed_ID !== '.' ? row.PubMed_ID : []

          return (
            <Stack
              maxWidth={'100px'}
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              {PubMed_ID.map((item: string, i: number) => {
                return (
                  <TypographyA
                    sx={{
                      color: 'primary.main',
                      cursor: 'point'
                    }}
                    key={item}
                    onClick={() => {
                      window.open(
                        `https://pubmed.ncbi.nlm.nih.gov/${PubMed_ID[i]}/`
                      )
                    }}
                  >{`${item}`}</TypographyA>
                )
              })}
            </Stack>
          )
        }
      }
    ]
  }, [props])

  React.useImperativeHandle(ref, () => ({
    column
  }))

  return <></>
})

export default columns2Thalassemia
